import React from "react";
import DataTable from "react-data-table-component";
import { DeleteIcon } from "../../assets/icons/user-access-icons/delete-icon";

const UserList = ({ usersRoleBase, setIsDeletePopup,userList }) => {
  console.log("usersRoleBase", usersRoleBase);

  const customStyles = {
    table: {
      style: {
        borderRadius: "6px",
        overflow: "hidden",
        border: "1px solid #E0E7F0",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#EAEDF2",
        color: "#1B2A3D",
        fontWeight: "600",
        fontSize: "16px",
        padding: "14px 20px",
        borderRight: "1px solid #C8D6E6",
        fontFamily: "Montserrat",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        padding: "20px",
        fontWeight: 600,
        height: "66px",
        fontFamily: "Montserrat",
        color: "#373737",
      },
    },
  };

  const userData = Array.isArray(usersRoleBase)
    ? usersRoleBase.map((t) => {
        return {
          accountName: `${t.firstName || ""} ${t.lastName || ""}`.trim(),
          userName: t.userName,
          email: t.email,
          roleName: t.roleName,
          userId:t.userId,
          isActive:t.isActive
        };
      })
    : [];

  console.log("usersRoleBase userData", userData);

 

  return (
    <div className="main-body px-[30px] pt-4 table_border flex justify-between">
      <DataTable
        columns={userList}
        data={userData}
        customStyles={customStyles}
      />
    </div>
  );
};

export default UserList;
